<template>
  <div>

    <h3 v-if="title">{{ title }}</h3>
    <div class="row">
      <PackageOrderForm ref="packageOrderFormComponent"/>
    </div>
    <div class="row">
      <PackagesOrderExcelImportForm ref="packagesOrderExcelImportForm" :orderToDivide="isOrderToDivide"
                                    :key="isOrderToDivide"/>
    </div>


    <button class="btn btn-primary" @click="saveData">
      Importuj
    </button>

  </div>


</template>


<script>
import {defineComponent} from 'vue'
import PackagesOrderExcelImportForm from "./PackagesOrderExcelImportForm.vue";
import PackageOrderForm from "./PackageOrderForm.vue";
import {log} from "@/state/pinia/log";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";

import Swal from "sweetalert2";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default defineComponent({
  name: "PackageOrderImportAssistant",
  components: {PackagesOrderExcelImportForm, PackageOrderForm},
  props: {
    title: String,
  },
  emits: ['onImportSuccess'],
  data() {
    return {
      orderData: null,
      drugstoresOrderItems: null,
      orderFile: null,
      isOrderToDivide: false,
    }
  },
  computed:{
    packagesModule(){
      return usePackagesManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {

    applyOrderDataForm() {
      // Spróbuj wywołać onApply w komponencie dziecka (jeśli istnieje)
      const child = this.$refs.packageOrderFormComponent;
      console.log("Child:")
      console.log(child)

      if (child && child.onApplyData) {
        // Jeśli onApply zwraca Promise, poczekaj na zakończenie
        const result = child.onApplyData;// onApplyData in packageOrderFormComponent is an object type
        console.log("Result from onApply")
        console.log(result)
        if (result) {
          this.saveFormData(result)
          return true;
        }
      }
      return false;
    },
    saveFormData(dataToSave) {
      this.orderData = dataToSave.order
      this.isOrderToDivide = this.orderData.toDivide
    },
    applyOrderFileDataForm() {
      // Spróbuj wywołać onApply w komponencie dziecka (jeśli istnieje)
      const child = this.$refs.packagesOrderExcelImportForm;
      if (child && child.onApplyData) {
        const result = child.onApplyData(); // onApplyData in packagesOrderExcelImportForm is a fuction type
        if (result) {
          console.log("Fetched result from file validation:")
          console.log(result)
          this.saveFileData(result)
          return true
        }
      }
      return false;
    },

    saveFileData(fileData) {
      this.drugstoresOrderItems = fileData.items
      this.orderFile = fileData.file
    },
    saveData() {
      const orderDataValid = this.applyOrderDataForm();
      if(!orderDataValid){
        Swal.fire({
          title: "Dane niepoprawne!",
          text: "Uzupełnij wymagane dane zamówienia, aby zaimportować plik",
          icon: "error",
          customClass: {
            container: "swal-highest"
          },

        })
        return;
      }
      const fileDataValid = this.applyOrderFileDataForm();
      if(!fileDataValid){
        Swal.fire({
          title: "Dane niepoprawne!",
          text: "Uzupełnij wymagane dane pliku, aby zaimportować plik",
          icon: "error",
          customClass: {
            container: "swal-highest"
          },

        })


        return;
      }


      var exportPayload = {
        order: this.orderData,
        items: this.drugstoresOrderItems
      };

      log.log("Request payload import order:");
      log.log(exportPayload);
      this.packagesModule.httpAddGroupOrderParsedFromFile(exportPayload)
          .then((response) => {
            if (response.status === 200) {
              log.log("Add order response:")
              log.log(response)
              const assignedGroupGuid =
                  response.data.payload && response.data.payload.length > 0 ? response.data.payload : null;
              // now we can save original file
              log.log(assignedGroupGuid)
              if (assignedGroupGuid == null) {
                this.$emit("onImportSuccess", "false");
                apiRequestsHelper.handleResponseWithDialogs(response, true);
                return;
              }

              let formData = new FormData();
              formData.append("file", this.orderFile);
              var fileRequest = {
                fileToSend: formData,
                orderGuid: assignedGroupGuid,
                isGroupOrder: true
              };

              this.packagesModule.httpSavePackageOrderFile(fileRequest).then((saveFileResponse) => {
                if (saveFileResponse.status === 200) {
                  this.$emit("onImportSuccess", "true");
                }

                apiRequestsHelper.handleResponseWithDialogs(saveFileResponse, true);
              })
                  .catch((saveFileResponseError) => {
                    apiRequestsHelper.catchResponseError(saveFileResponseError, "httpSavePackageOrderFile");
                  });


            } else {
              apiRequestsHelper.handleResponseWithDialogs(response, true);
            }
          })
          .catch((error) => {
            apiRequestsHelper.catchResponseError(error, "httpAddGroupOrderParsedFromFile");
          })

    }
  }
})
</script>


<style scoped>

</style>
